import type { BtcApplication, Caixinha } from '../types';

/**
 * Valor de uma caixinha numa data: parte do último snapshot até ali e aplica
 * os lançamentos posteriores. Sem snapshot, soma só os lançamentos.
 */
export function getCaixinhaCurrentValue(caixinha: Caixinha, at: Date): number | null {
  const cutoff = at.getTime();
  const snapshots = caixinha.snapshots.filter((s) => s.date.getTime() <= cutoff);
  const logs = caixinha.log.filter((l) => l.date.getTime() <= cutoff);

  const lastSnapshot =
    [...snapshots].sort((a, b) => b.date.getTime() - a.date.getTime())[0] ?? null;

  if (lastSnapshot) {
    return (
      lastSnapshot.value +
      logs
        .filter((l) => l.date.getTime() > lastSnapshot.date.getTime())
        .reduce((sum, l) => sum + l.value, 0)
    );
  }

  return logs.length > 0 ? logs.reduce((sum, l) => sum + l.value, 0) : null;
}

export function getCaixinhasTotal(caixinhas: Caixinha[], at: Date): number {
  return caixinhas.reduce((sum, c) => sum + (getCaixinhaCurrentValue(c, at) ?? 0), 0);
}

/** Bitcoin acumulado, já descontada a taxa de cada aporte. */
export function getTotalBtc(applications: BtcApplication[]): number {
  return applications.reduce((sum, a) => sum + a.btcAmount - a.feeBtc, 0);
}
